import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useFeatureToggles } from '@grandvisionhq/state';
import { ProductBanner } from '../ProductBanner/ProductBanner/ProductBanner.js';
import { ProductListingGallery } from './ProductListingGallery.js';

var ProductListingGalleryWrapper = (_param)=>{
    var { className  } = _param, props = swcHelpers.objectWithoutProperties(_param, [
        "className"
    ]);
    const { isRestructuredProductBlockEnabled  } = useFeatureToggles();
    if (isRestructuredProductBlockEnabled) {
        return /*#__PURE__*/ React.createElement(ProductListingGallery, swcHelpers.extends({}, props));
    }
    return /*#__PURE__*/ React.createElement(ProductBanner, swcHelpers.extends({
        className: className
    }, props));
};

export { ProductListingGalleryWrapper };
//# sourceMappingURL=ProductListingGalleryWrapper.js.map
